module.exports = __webpack_public_path__ + "img/logo5.dadcb193.png";